import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractWidgetComponent, AppClientConfiguration, AppClientConfigurationService, AppFrameContextService, AppServerAPI, ContextChange } from '@sdbn/common';
import { interval, Observable, Subscription } from 'rxjs';
import { GcConnectionInfo } from '../model/gc-connection-info';


@Component({
    selector: 'app-gc-connection',
    templateUrl: './gc-connection.component.html',
    styleUrls: ['./gc-connection.component.scss'],
    standalone: false
})
export class GcConnectionComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  darkMode = false;
  refreshEnabled = true;
  refreshInterval = 20000;
  refreshTimer: Subscription;

  displayKey: string;

  foregroundColor: string = this.darkMode ? '#ffffff' : '#000000';
  backgroundColor: string = this.darkMode ? '#000000' : '#ffffff';

  info = new GcConnectionInfo();

  qrScale = 4;

  tenant?: string;

  serverRoot = this.appClientConfiguration.serverURLRoot;

  constructor(
    private appFrameContextService: AppFrameContextService,
    private appServerAPI: AppServerAPI,
    public configurationService: AppClientConfigurationService,
    private appClientConfiguration: AppClientConfiguration
  ) {
    super();
    this.tenant = this.appFrameContextService.tenant.value?.key;
    this.updateColorScheme();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.darkMode = this.widgetReference.data.darkMode;
    this.refreshEnabled = this.widgetReference.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }

    // TODO Support für mehrere displays über konfiguration des Widgets
    this.displayKey = this.configurationService.getPropertyValue('display.gc-connection.display-key', null);

    this.foregroundColor = this.darkMode ? '#ffffff' : '#000000';
    this.backgroundColor = this.darkMode ? '#000000' : '#ffffff';

    this.updateColorScheme();
    this.updateConnectionInfo();
    this.registerRefreshTimer();
  }

  ngOnInit(): void {
    this.refreshScale(window.innerWidth, window.innerHeight);
  }

  refreshScale(width: number, height: number) {
    const qrWidth = width / 2.7;
    this.qrScale = qrWidth / 40;
  }

  ngOnDestroy() {
    if (this.refreshTimer != null) {
      this.refreshTimer.unsubscribe();
    }
  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (this.appClientConfiguration.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.updateConnectionInfo();
      }
      );
    } else {
      console.log('Autoreload of GcConnectionComponent disabled');
    }
  }

  private updateConnectionInfo() {
    this.getGcConnectionInfo(this.displayKey).subscribe(
      result => {
        this.info = new GcConnectionInfo(result);
      },
      error => {
        this.info = new GcConnectionInfo();
      }
    );
  }

  private getGcConnectionInfo(displayKey: string): Observable<GcConnectionInfo> {
    const url = `/client/displays/gc-connection-info`;
    return this.appServerAPI.execute<GcConnectionInfo>(url, displayKey);
  }

  onResize(event) {
    this.refreshScale(event.target.innerWidth, event.target.innerHeight);
  }

  private updateColorScheme() {
    this.foregroundColor = this.darkMode ? '#ffffff' : '#000000';
    this.backgroundColor = this.darkMode ? '#000000' : '#ffffff';
  }
}
